import React, { useState } from "react";
import { Button, Modal } from "antd";

function LoadingButton({
  title,
  action,
  styles = "",
  type = "primary",
  Btntype = "button",
  icon = "",
}) {
  const [state, setState] = useState({
    loading: false,
    iconLoading: false,
  });

  function enterLoading() {
    setState({ loading: true });
  }
  function exitLoading() {
    setState({ loading: false });
  }

  async function onClickHandler() {
    enterLoading();
    try{
      action()
    }catch(error){
      Modal.error({
        title:"خطا!",
        content:"مشکلی هنگام انجام عملیات پیش آمد."
      })
    }
    exitLoading();
    
  }

  return (
    <Button
      type={type}
      className={styles}
      loading={state.loading}
      htmlType={Btntype}
      icon={icon}
      onClick={onClickHandler}
    >
      {title}
    </Button>
  );
}

export default LoadingButton;
